import { Injectable } from '@angular/core';

const STORAGE_KEY = 'logist-time-management.source-client-id';

@Injectable({ providedIn: 'root' })
export class LogistTimeManagementClientIdService {
  readonly id = this.getOrCreateId();

  private getOrCreateId(): string {
    const storage = globalThis.sessionStorage;
    const existing = storage?.getItem(STORAGE_KEY);

    if (existing) return existing;

    const id =
      globalThis.crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`;

    storage?.setItem(STORAGE_KEY, id);

    return id;
  }
}
